import { render, staticRenderFns } from "./BookingDocumentDownloadButton.vue?vue&type=template&id=1a4e9ad4&scoped=true"
import script from "./BookingDocumentDownloadButton.vue?vue&type=script&lang=js"
export * from "./BookingDocumentDownloadButton.vue?vue&type=script&lang=js"
import style0 from "./BookingDocumentDownloadButton.vue?vue&type=style&index=0&id=1a4e9ad4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4e9ad4",
  null
  
)

export default component.exports